module.exports = __webpack_public_path__ + "static/media/subscriber_journals.10de0df3.xml";


//////////////////
// WEBPACK FOOTER
// ./public/subscriber_journals.xml
// module id = 1824
// module chunks = 1